import { Component, Input, ElementRef, HostListener, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { BbTableService, BbTableSelectOption, TableRow, TableColumn } from '../../../services/bb-table.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-table-row',
	templateUrl: './bb-table-row.component.html',
	styleUrls: ['./bb-table-row.component.scss']
})

export class BbTableRowComponent implements OnInit, OnDestroy {

	@Input() row: TableRow;
	@Input() theme: string;
	@Input() colspan: number;

	visibleColumns: number;
	columnsChangedSubscription: Subscription;
	multiSelect: boolean;
	scrollSelectedIntoViewSubscription: Subscription;
	shiftDown = false;
	scrollingRow: boolean;
	touchMoveListener: any;

	constructor(
		private bbTableService: BbTableService,
		private element: ElementRef,
		private renderer: Renderer2
	) { }

	@HostListener('click', ['$event'])
	selectRow(event: MouseEvent) {
		if (this.row && this.row.id) {
			this.bbTableService.selectRow(this.row.id, event.shiftKey, (event.metaKey || event.ctrlKey));
		}
	}

	@HostListener('dblclick', ['$event'])
	doubleClickRow(event: MouseEvent) {
		const element = event.target as HTMLElement;
		if (element.tagName.toLowerCase() !== 'bb-check' && this.row && this.row.id) {
			this.bbTableService.doubleClickRow(this.row.id);
		}
	}

	@HostListener('touchstart', ['$event'])
	touchStartRow(event: Event) {
		this.touchMoveListener = this.renderer.listen(document, 'touchmove', (ev: Event) => {
			this.touchMoveRow(ev);
		});
	}

	@HostListener('touchend', ['$event'])
	touchEndRow(ev: Event) {
		if (this.touchMoveListener) {
			this.touchMoveListener();
		}
		if (!this.scrollingRow && ev.target && (ev.target as HTMLElement).localName !== 'bb-check') {
			this.bbTableService.doubleClickRow(this.row.id);
		}
		this.scrollingRow = false;
	}

	ngOnInit() {
		this.multiSelect = (this.bbTableService.selectOption === BbTableSelectOption.multi);

		if (typeof this.colspan === 'undefined') {
			this.colspan = 6;
		}

		// when column visibility changes...
		this.columnsChangedSubscription = this.bbTableService.columnsChangedObservable
			.subscribe((columns: TableColumn[]) => {
				this.determineVisibleColumns(columns);
			});

		// when table visibility changes scroll into view
		this.scrollSelectedIntoViewSubscription = this.bbTableService.scrollSelectedIntoViewObservable
			.subscribe((visible: boolean) => {
				if (visible) {
					this.scrollSelectedIntoView();
				}
			});

		this.scrollSelectedIntoView();
	}

	ngOnDestroy() {
		this.columnsChangedSubscription?.unsubscribe?.();
	}

	scrollSelectedIntoView() {
		if (
			this.bbTableService.selectOption === BbTableSelectOption.single &&
			this.row.selected &&
			// extra checks because this will error if the component is active but hidden
			this.element && this.element.nativeElement &&
			this.element.nativeElement.offsetParent && this.element.nativeElement.offsetParent.parentNode
		) {
			// we assume that if this row was initialized selected, on a single bb table, we might need to scroll the element into view
			const parent = this.element.nativeElement.offsetParent.parentNode;
			const rect = this.element.nativeElement.getBoundingClientRect();
			const bottom = (rect.top + rect.height) - parent.getBoundingClientRect().top;

			if (bottom > parent.offsetHeight) {
				this.element.nativeElement.scrollIntoView();
			}
		}
	}

	determineVisibleColumns(columns: TableColumn[]) {
		let visibleColumns = 0;

		columns.forEach((column: TableColumn) => {
			if (column.visible) {
				visibleColumns++;
			}
		});

		this.visibleColumns = visibleColumns;
	}

	checkboxClicked(event: MouseEvent) {
		if (event.shiftKey) {
			this.shiftDown = true;
		}
	}

	touchMoveRow(ev: Event) {
		this.scrollingRow = true;
	}

	checkboxChanged() {
		if (this.row && this.row.id) {
			this.bbTableService.selectRow(this.row.id, this.shiftDown, true);
		}
		this.shiftDown = false;
	}
}
